module.exports = __webpack_public_path__ + "static/media/Aether.f2fcad64.svg";